import type { StpInstance } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { initialTechnologies } from 'components/Graph/GraphState';
import { updateStpInstanceIsolate } from 'components/Graph/commands/updateStpInstanceIsolate';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface ClearStpInstancesCommand {
  instances: StpInstance[];
}

export const clearStpInstances: GraphCommandFactory<ClearStpInstancesCommand> =
  (cmdContext, dispatch) => (command) => {
    cmdContext.updateState((draft) => {
      const {
        technologies: {
          selectedTechnologies: {
            stpInstances = initialTechnologies.stpInstances,
          },
        },
      } = draft;

      stpInstances.instances = stpInstances.instances.filter(
        (selectedInstance) =>
          !command.instances.some(
            ({ rootId, vlanId }) =>
              rootId === selectedInstance.rootId &&
              vlanId === selectedInstance.vlanId,
          ),
      );
    });

    const { instances = [] } =
      cmdContext.getState().technologies.selectedTechnologies.stpInstances ??
      initialTechnologies.stpInstances;

    if (instances.filter(prop('visible')).length === 0) {
      dispatch(updateStpInstanceIsolate, { isolate: false });
    }
  };
